import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import ProgressBar from "../components/ProgressBar";
import Popup from './Popup';
import './SelectSkinTone.css';

const SelectSkinTone = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // State variables for handling selected skin tone, skin tone options, error/loading states, and popup visibility
  
  const [selectedSkinTone, setSelectedSkinTone] = useState(null);
  const [skinToneOptions, setSkinToneOptions] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [showSkipPopup, setShowSkipPopup] = useState(false);

  // Check if coming from profile page
  const fromProfile = location.state?.fromProfile;

  // useEffect to load skin tone options and check for any stored skin tone in sessionStorage
  
  useEffect(() => {
    fetchSkinToneOptions();

    // Retrieve selected values from sessionStorage
    const storedSkinTone = sessionStorage.getItem('skin-tone') || null;
    setSelectedSkinTone(storedSkinTone ? JSON.parse(storedSkinTone) : null);
  }, []);

  // Function to fetch skin tone options from the API
  const fetchSkinToneOptions = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      if (!token) {
        setSelectedSkinTone(null);
        return;
      }
      
      const response = await fetch('https://dev-api.curu.com.au/api/skin-tone', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch skin tone options.');
      }

      const data = await response.json();
      setSkinToneOptions(data);
    } catch (err) {
      setError('Could not load skin tone options. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  // Function to handle updating the skin tone selection in the user profile
  const handleUpdateClick = async () => {
    const storedSkinTone = sessionStorage.getItem('skin-tone');

    // Safely parse stored skin tone and extract its ID
    const parseAndExtractId = (storedValue) => {
      try {
        const parsedValue = JSON.parse(storedValue);
        return parsedValue?.id || null;
      } catch {
        return null;
      }
    };

    const skinToneId = parseAndExtractId(storedSkinTone);

    const quizData = {
      skin_tone: skinToneId,
    };

    console.log('Skin quiz data to store in database:', quizData);

    try {
      const response = await fetch('https://dev-api.curu.com.au/api/profile', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(quizData)
      });

      // Check response status and set skin tone options if successful
      if (!response.ok) {
        throw new Error('Failed to save the skin quiz data.');
      }

      // Optionally navigate after successful update
      navigate('/user-profile'); // Change this to your desired route after update
    } catch (error) {
      console.error('Error saving quiz data:', error.message);
      alert('There was a problem saving your quiz data. Please try again.');
    }
  };
// Function to handle selection of a skin tone and store it in sessionStorage
  
  const handleSkinToneSelect = (tone) => {
    setSelectedSkinTone(tone);
    sessionStorage.setItem('skin-tone', JSON.stringify(tone));
  };
// Navigation handlers for Next and Back buttons
  const handleNextClick = () => {
    navigate('/select-undertone');
  };

  const handleBackClick = () => {
    navigate('/skin-sensitivity');
  };

  // Handler to show the skip confirmation popup
  const handleSkipClick = () => {
    setShowSkipPopup(true);
  };
// Handler to confirm skip and proceed to the next page
  const handleSkipConfirm = () => {
    setShowSkipPopup(false);
    navigate('/select-undertone');
  };

  // Disable Next button if no skin tone is selected
  const isNextButtonDisabled = !selectedSkinTone;

  return (
    <div className="page-containertone">
      <div className="skin-tone-container">
        {/* Display Skip button if not coming from profile */}
      {!fromProfile && (
        <button className="skip-link-skin-tone" onClick={handleSkipClick}>Skip</button>
      )}
      {/* ProgressBar component to indicate the user's progress */}
        <ProgressBar currentStep={3} comboType="combo2" />
        <div className="title-container-skin-undertone">
    <h1 className="title-skin-undertone">Select Your Skin Tone</h1>
</div>
{/* Conditional rendering for loading, error, or skin tone selection options */}
       
        {loading ? (
          <p>Loading skin tone options...</p>
        ) : error ? (
          <p className="error">{error}</p>
        ) : (
          <div className="selection-toneboxes2">
            {/* Map through skin tone options to render selectable skin tones */}
            {skinToneOptions.map((tone) => (
              <div
                key={tone.id}
                className={`selection-toneitem2 ${selectedSkinTone?.id === tone.id ? 'selected' : ''}`}
                onClick={() => handleSkinToneSelect(tone)}
              >
                <img src={tone.image} alt={tone.name} className="tone-image" />
                <div className="sensitivity-content">
                  <label className="toneradio-label">
                    <input
                      type="radio"
                      name="skinTone"
                      value={tone.id}
                      checked={selectedSkinTone?.id === tone.id}
                      onChange={() => handleSkinToneSelect(tone)}
                      className="radio-input"
                    />
                    <span className="tone-name">{tone.name}</span>
                  </label>
                </div>
              </div>
            ))}
          </div>
        )}
         {/* Container for Back, Next, and Update buttons with conditional rendering */}
        

        <div className="buttons-container-skin-tone">
          {/* Conditional rendering for the Back button */}
          {!fromProfile && (
            <button className="back-button-skin-tone" onClick={handleBackClick}>Back</button>
          )}
          {!fromProfile ? (
            <button
              className={`next-button-skin-tone ${isNextButtonDisabled ? 'disabled' : ''}`}
              onClick={isNextButtonDisabled ? null : handleNextClick}
              disabled={isNextButtonDisabled}
            >
              Next
            </button>
          ) : (
            <>
            <button
              className="close-button-skin-tone"
              onClick={() => navigate('/user-profile')}
              >
                Close
              </button>
            <button
              className="update-button-skin-tone"
              onClick={handleUpdateClick}
              disabled={isNextButtonDisabled}
            >
              Update
            </button>
            </>
          )}
        </div>

{/* Conditional rendering for the skip confirmation popup */}
        {showSkipPopup && (
          <Popup
            isVisible={showSkipPopup}
            title="Skip Skin Tone"
            onClose={() => setShowSkipPopup(false)}
            onConfirm={handleSkipConfirm}
          />
        )}
      </div>
    </div>
  );
};

export default SelectSkinTone;
